import React from 'react';

export const ActivityScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-FigtreeBold font-bold text-ui_blue mb-2">
            Activity screen
          </h1>
        </div>
      </div>
    </div>
  );
};

